import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'

import { GlgButton } from 'SharedComponents'

import QuickEventButton from './action_buttons/quick_event_button'
import CreateEventButton from './action_buttons/create_event_button'
import CloneEventButton from './action_buttons/clone_event_button'
import ManageGroupsButton from './action_buttons/manage_groups_button'
import CreateEventAndLeagueButtonSimGolf from './sim_golf/action_buttons/create_event_and_league_button_sim_golf'

const CustomerActionsComponent = ({
  openPopup, userIsCustomerManager, userIsTourManager, dataIsLoading, userCanCloneEvents,
  isSalesDemo, userIsVisageSuperAdmin, manageVisageURL, customerOnlyEvents, customerOnlyLeagues, customerTripOnly, customerNeedsSubscription,
  canCreateTrips, canCreateDCP, isSimGolf, userIsGroupLeader, manageGroupsURL, managedGroups,
}) => {
  const groupLeaderCannotClone = userIsGroupLeader && (!userCanCloneEvents || isSalesDemo)
  const showCloneButton = (!isSalesDemo && userCanCloneEvents) || groupLeaderCannotClone

  return (
    <Fragment>
      {(isSimGolf) ?
        (<CreateEventAndLeagueButtonSimGolf
          openPopup={ openPopup }
          customerOnlyEvents={ customerOnlyEvents }
          customerNeedsSubscription={ customerNeedsSubscription}
          customerOnlyLeagues={ customerOnlyLeagues}
          canCreateTrips={ canCreateTrips }
          disabled={ dataIsLoading }
          canCreateDCP={ canCreateDCP }
          userIsCustomerManager={ userIsCustomerManager }
        />) :
        (userIsCustomerManager || userIsTourManager || userIsGroupLeader) && (!customerTripOnly) && (
        <Row>
          {manageGroupsURL && (
            <Col sm={12} lg={ true }>
              <ManageGroupsButton manageGroupsURL={ manageGroupsURL } managedGroups={ managedGroups } userIsGroupLeader={ userIsGroupLeader } />
            </Col>
          )}
          {!customerOnlyLeagues && !userIsGroupLeader && (
            <Col sm={ 12 } lg={ true }>
              <QuickEventButton
                openPopup={ openPopup }
                disabled={ dataIsLoading }
              />
            </Col>
          )}

          <Col sm={ 12 } lg={ true }>
            <CreateEventButton
              openPopup={ openPopup }
              customerOnlyEvents={ customerOnlyEvents }
              customerNeedsSubscription={ customerNeedsSubscription}
              customerOnlyLeagues={ customerOnlyLeagues}
              canCreateTrips={ canCreateTrips }
              disabled={ dataIsLoading }
              canCreateDCP={ canCreateDCP }
              userIsGroupLeader={ userIsGroupLeader }
            />
          </Col>
          {showCloneButton && (
            <Col sm={ 12 } lg={ true } className='no-lite'>
              <CloneEventButton
                openPopup={ openPopup }
                customerOnlyEvents={ customerOnlyEvents }
                customerNeedsSubscription={ customerNeedsSubscription}
                customerOnlyLeagues={ customerOnlyLeagues }
                canCreateTrips={ canCreateTrips }
                disabled={ dataIsLoading || groupLeaderCannotClone }
                disabledStyle={ groupLeaderCannotClone }
                canCreateDCP={ canCreateDCP }
                userIsGroupLeader={ userIsGroupLeader }
              />
            </Col>
          )}
        </Row>
      )}
      {userIsVisageSuperAdmin && (
        <GlgButton
          text='Manage Visage Support'
          href={ manageVisageURL }
          className='add-margin-bottom-10'
        />
      )}
    </Fragment>
  )
}

CustomerActionsComponent.propTypes = {
  userIsCustomerManager: PropTypes.bool.isRequired,
  userIsTourManager: PropTypes.bool.isRequired,
  dataIsLoading: PropTypes.bool.isRequired,
  userCanCloneEvents: PropTypes.bool.isRequired,
  isSalesDemo: PropTypes.bool,
  userIsVisageSuperAdmin: PropTypes.bool,
  manageVisageURL: PropTypes.string,
  customerOnlyEvents: PropTypes.bool.isRequired,
  customerOnlyLeagues: PropTypes.bool.isRequired,
  canCreateTrips: PropTypes.bool.isRequired,
  customerNeedsSubscription: PropTypes.bool.isRequired,
  customerTripOnly: PropTypes.bool.isRequired,
  openPopup: PropTypes.func.isRequired,
  canCreateDCP: PropTypes.bool,
  isSimGolf: PropTypes.bool,
  userIsGroupLeader: PropTypes.bool.isRequired,
  manageGroupsURL: PropTypes.string,
  managedGroups: PropTypes.array,
}

CustomerActionsComponent.defaultProps = {
  managedGroups: [],
}

export default CustomerActionsComponent